export default "__VITE_ASSET__Ngx7QOjW__"